import { Controller } from "@hotwired/stimulus"

// Syncs the stepper UI and order summary visibility when
// the checkout Turbo Frame loads a new step.
export default class extends Controller {

  // Called by Turbo's frame-load event on the checkout-step frame.
  // Wire up: data-action="turbo:frame-load@document->checkout#onStepLoad"
  onStepLoad(event) {
    const frame = document.getElementById("checkout-step")
    if (!frame || event.target !== frame) return

    const stepEl = frame.querySelector("[data-checkout-step-step-value]")
    if (!stepEl) return

    const step = parseInt(stepEl.dataset.checkoutStepStepValue || "1", 10)
    this.updateStepper(step)
    this.updateLayout(step)
  }

  updateStepper(current) {
    document.querySelectorAll("[data-step-id]").forEach(el => {
      const id = parseInt(el.dataset.stepId, 10)
      const circle = el.querySelector("[data-step-circle]")
      const connector = el.querySelector("[data-step-connector]")

      if (!circle) return

      circle.classList.remove(
        "bg-emerald", "text-white", "bg-navy", "ring-4", "ring-navy/10", "bg-light", "text-muted-foreground"
      )

      if (id < current) {
        circle.classList.add("bg-emerald", "text-white")
        circle.innerHTML = `<svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="3" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>`
      } else if (id === current) {
        circle.classList.add("bg-navy", "text-white", "ring-4", "ring-navy/10")
        circle.textContent = id
      } else {
        circle.classList.add("bg-light", "text-muted-foreground")
        circle.textContent = id
      }

      const text = el.querySelector("[data-step-text]")
      if (text) {
        text.classList.remove("text-navy", "text-muted-foreground")
        if (id <= current) {
          text.classList.add("text-navy")
        } else {
          text.classList.add("text-muted-foreground")
        }
      }

      if (connector) {
        connector.classList.toggle("bg-emerald", id < current)
        connector.classList.toggle("bg-light", id >= current)
      }
    })
  }

  updateLayout(step) {
    const layout = document.getElementById("checkout-layout")
    const summary = document.getElementById("order-summary")
    if (!layout || !summary) return

    if (step === 4) {
      layout.classList.remove("lg:grid-cols-[1fr_380px]")
      layout.classList.add("lg:grid-cols-1")
      summary.classList.add("hidden")
    } else {
      layout.classList.add("lg:grid-cols-[1fr_380px]")
      layout.classList.remove("lg:grid-cols-1")
      summary.classList.remove("hidden")
    }
  }
}
